module.exports = __webpack_public_path__ + "img/ES0220.095d0a3f.png";